export function scheduleDeferred(task, { timeout = 2500 } = {}) {
    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => task(), { timeout });
        return;
    }

    if (document.readyState === 'complete') {
        setTimeout(task, 0);
        return;
    }

    window.addEventListener('load', () => task(), { once: true });
}
